/** New Chromium uses loopback-network; older releases use local-network-access. */
export async function loopbackPermission(): Promise<PermissionState | 'unsupported'> {
  // A loopback page is already in the destination's address space. Chromium can
  // report 'prompt' here even though same-space fetches need no LNA permission.
  // Fetch still enforces the browser's own network rules.
  if (['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) return 'unsupported';
  for (const name of ['loopback-network', 'local-network-access']) {
    try {
      const result = await navigator.permissions.query({ name: name as PermissionName });
      return result.state;
    } catch {
      /* Unsupported permission name/browser: try the older name. */
    }
  }
  return 'unsupported';
}
export async function checkDesktopPresence(sub: string, signal: AbortSignal): Promise<boolean> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(sub));
  if (signal.aborted) return false;
  const account = Array.from(new Uint8Array(digest), byte =>
    byte.toString(16).padStart(2, '0'),
  ).join('');
  const result = await fetch('http://127.0.0.1:47834/v1/presence', {
    method: 'GET',
    credentials: 'omit',
    cache: 'no-store',
    redirect: 'error',
    headers: { 'X-Jot-Account': account },
    signal,
  });
  return result.status === 204;
}
